"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VariableSizeListStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _reactWindow = require("react-window");
const VariableSizeListStyled = (0, _styled.default)(_reactWindow.VariableSizeList)`
    & > div {
        position: relative;
        margin: 8px 0;
    }
`;
exports.VariableSizeListStyled = VariableSizeListStyled;
//# sourceMappingURL=VariableSizeListStyled.js.map